import { Cake, Gift, Info, UtensilsCrossed } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useModals } from "@/components/ModalContext";
import { ENCARGOS } from "@/constants/site";
import { Reveal } from "@/components/Reveal";

const ICONOS = { utensils: UtensilsCrossed, cake: Cake, gift: Gift };

export const Encargos = () => {
  const { openPresupuesto } = useModals();

  return (
    <section
      id="encargos"
      data-testid="encargos-section"
      className="bg-crema/40 py-20 sm:py-28 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-12">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_60px_rgba(58,36,24,0.18)]">
            <img
              src={ENCARGOS.imagen}
              alt="Tarta de boda personalizada de varios pisos elaborada por Rawan"
              loading="lazy"
              className="h-[420px] w-full object-cover lg:h-[560px]"
              data-zoomable
            />
            <span className="absolute bottom-5 left-5 rounded-full bg-fondo/95 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-chocolate backdrop-blur">
              Tartas de boda & celebraciones
            </span>
          </div>
          <div className="mt-5 grid grid-cols-2 gap-4">
            {ENCARGOS.imagenesSecundarias.map((img) => (
              <img
                key={img.src}
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="h-44 w-full rounded-2xl object-cover shadow-md sm:h-52"
              />
            ))}
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-cafe">
              <span aria-hidden className="h-px w-9 bg-cafe/60" />
              Bodas y celebraciones
            </p>
            <h2 className="mt-6 font-serif text-3xl leading-[1.14] tracking-tight text-tinta sm:text-4xl lg:text-[2.9rem]">
              Encargos para{" "}
              <em className="font-garamond font-medium italic text-cafe">
                Bodas y Celebraciones.
              </em>
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-tinta/70 sm:text-lg">
              Elaboraciones artesanales para hacer de cada celebración un momento
              especial.
            </p>
            <p
              data-testid="encargos-nota"
              className="mt-6 flex items-start gap-3 rounded-2xl border border-arena bg-fondo px-5 py-4 text-sm leading-relaxed text-tinta/80"
            >
              <Info className="mt-0.5 h-4 w-4 shrink-0 text-cafe" strokeWidth={1.8} />
              <span>
                Preparación de comida y repostería por encargo.{" "}
                <strong className="font-semibold text-chocolate">
                  No ofrecemos servicio de catering.
                </strong>
              </span>
            </p>
          </Reveal>

          <div className="mt-10 space-y-8">
            {ENCARGOS.bloques.map((bloque, i) => {
              const Icon = ICONOS[bloque.icon];
              return (
                <Reveal
                  key={bloque.titulo}
                  delay={0.1 + i * 0.1}
                  data-testid={`encargos-bloque-${i + 1}`}
                  className="border-t border-arena/70 pt-7"
                >
                  <div className="flex items-center gap-3">
                    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-arena/60">
                      <Icon className="h-5 w-5 text-chocolate" strokeWidth={1.7} />
                    </span>
                    <h3 className="font-serif text-xl text-tinta sm:text-2xl">
                      {bloque.titulo}
                    </h3>
                  </div>
                  {bloque.items && (
                    <ul className="mt-4 flex flex-wrap gap-2">
                      {bloque.items.map((item) => (
                        <li
                          key={item}
                          className="rounded-full border border-arena bg-fondo px-4 py-1.5 text-xs font-medium text-cafe"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                  {bloque.descripcion && (
                    <p className="mt-3 text-sm leading-relaxed text-tinta/65 sm:text-base">
                      {bloque.descripcion}
                    </p>
                  )}
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.2}>
            <Button
              data-testid="encargos-presupuesto-button"
              onClick={openPresupuesto}
              className="mt-10 rounded-full px-8 py-6 text-base"
            >
              Solicitar presupuesto
            </Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Encargos;
